module.exports = {
      id: "personalise-usage",
      viewBox: "0 0 14.128 12.555",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#personalise",
      toString: function () {
        return this.url;
      }
    }